import config from '../../config/config';
import { createQueryParams } from '@nexio/emvio-util-app';

export const EDIT_MERCHANT_FAILURE = 'MERCHANT_MANAGEMENT/EDIT_MERCHANT_FAILURE';
export const EDIT_MERCHANT_LOAD = 'MERCHANT_MANAGEMENT/EDIT_MERCHANT_LOAD';
export const EDIT_MERCHANT_SUCCESS = 'MERCHANT_MANAGEMENT/EDIT_MERCHANT_SUCCESS';

export const MERCHANTS_FAILURE = 'MERCHANT_MANAGEMENT/MERCHANTS_FAILURE';
export const MERCHANTS_LOAD = 'MERCHANT_MANAGEMENT/MERCHANTS_LOAD';
export const MERCHANTS_SUCCESS = 'MERCHANT_MANAGEMENT/MERCHANTS_SUCCESS';

export const fetchUrl = `${config.paymentApiUrl}/merchant`;

export function editMerchant(merchant) {
    return {
        failureActionTypeOrCreator: editMerchantFailureActionCreator,
        fetchParams: {
            body: [merchant],
            method: 'POST',
            url: `${config.paymentApiUrl}/enableMerchants`
        },
        loadActionTypeOrCreator: EDIT_MERCHANT_LOAD,
        successActionTypeOrCreator: EDIT_MERCHANT_SUCCESS
    };
}

export function editMerchantFailureActionCreator(error) {
    return {
        error,
        type: EDIT_MERCHANT_FAILURE
    };
}

export function getMerchantsFailureActionCreator(error) {
    return {
        error,
        type: MERCHANTS_FAILURE
    };
}

export function getMerchantsSuccessActionCreator(results) {
    return {
        count: results.count,
        pages: Math.ceil(results.count / results.limit),
        merchants: results.rows,
        type: MERCHANTS_SUCCESS
    };
}

export function getMerchants(filters, page, pageSize, sorters, merchantIds, columns) {
    const queryParamsString = createQueryParams({
        filters,
        merchantIds,
        page,
        pageSize,
        sorters,
        columns
    });

    return {
        failureActionTypeOrCreator: getMerchantsFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: MERCHANTS_LOAD,
        successActionTypeOrCreator: getMerchantsSuccessActionCreator
    };
}
